import {ISettingsReducer} from 'modules/reducers/settings';
import {createAction} from 'redux-act';


export const fetchBETime = createAction();
export const setBETimeDiff = createAction<number>();
export const setRegion = createAction<ISettingsReducer['region']>();
